import CBILLINGS from "@/constants/billings.js";
import PaymentService from "@/services/payment.js";
import { filter,some } from "lodash";

export default {
    methods: {
        async checkInvoiceStatus(invoiceId,isWaiveModal = false) {
            let proceed = true;
            let self = this;
            let warningMessage = null;
            await PaymentService.checkInvoiceStatus({
                invoices: [invoiceId]
            })
                .then(response => {
                    if (response.code == 200) {

                        const paidInvoices = filter(response.resources, {
                            status: CBILLINGS.INVOICE.TYPE_PAID
                        });

                        if (paidInvoices.length > 0) {
                            
                            warningMessage = "The invoice has been paid.";

                        } else if(isWaiveModal) {

                            if(some(response.resources, { status : CBILLINGS.INVOICE.TYPE_LOCKED})){
                                warningMessage = 'The invoice is locked';
                            } else if(some(response.resources, { status : CBILLINGS.INVOICE.TYPE_REOPENED})) {
                                warningMessage = 'The invoice is reopened';
                            }
                        }

                        if(warningMessage) {
                            this._message(
                                warningMessage,
                                "warning"
                            );

                            proceed = false;
                        }
                    }   
                })
                .catch(e => {
                    self._message("ERROR: Something wrong!", "danger");
                });
            return proceed;
        }
    }
};
